// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._2BbEGU1Yx{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}\n", ""]);
// Exports
exports.locals = {
	"selectable": "_2BbEGU1Yx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["off-screen"] + ""
};
module.exports = exports;
